module.exports = function getResource(label, vars = []) {
    let resources = {
        accountNavigation: 'Account Navigation',
        accountInformation: 'Account Information',
        recentOrders: 'Recent Orders',
        subscriptions: 'Subscriptions',
        reservations: 'Reservations',
        savedAddresses: 'Saved Addresses',
        paymentsCredits: 'Payments & Credits',
        emailPreferences: 'Email & Mail Preferences'
    };

    return resources[label];
};
